import { PagedPropertyRouteApplications } from '@common/entities';
import type { PropertyItem } from 'state/slices/propertiesSlice';

import { get, patch } from '../config';

const PROPERTY_END_POINTS = '/properties';
const GO_LIVE_ENDPOINT = `${PROPERTY_END_POINTS}/go-live`;

export interface GoLivePropertyStatus {
  propertyId: number;
  propertyName: string;
  parentPropertyId?: number;
  isLive: boolean;
  goLiveDate: string | null;
  checklist: Record<string, boolean>;
  /**
   * Non-fatal warning emitted by `PATCH /properties/go-live` when the local
   * activation row was written but the downstream Entrata
   * `ENABLE_LEASING_JOURNEY` preference save failed. When present, the
   * UI shows a yellow warning toast instead of the green success toast
   * so the operator knows reconciliation is needed.
   */
  preferenceWarning?: string;
}

export const getProperties = async (occupancyType = '') => {
  const params = {
    occupancyType,
  };
  const response = await get<PropertyItem[]>(PROPERTY_END_POINTS, {
    params,
  });
  return response;
};

export const getAllActiveProperties = async () => {
  const response = await get<
    { propertyId: number; propertyName: string; occupancyTypes?: string[] }[]
  >(`${PROPERTY_END_POINTS}/all`);
  return response;
};

export const getPropertyActiveRoutesAndApplications = async (
  clientId: number,
  pageNumber: number,
  pageSize: number,
) => {
  const params = {
    clientId,
    pageNumber,
    pageSize,
  };
  const response = await get<PagedPropertyRouteApplications>(
    `${PROPERTY_END_POINTS}/${clientId}/active-routes-and-applications`,
    { params },
  );
  return response.data;
};

export const getGoLiveStatuses = async () => {
  const response = await get<GoLivePropertyStatus[]>(GO_LIVE_ENDPOINT);
  return response.data;
};

export const markPropertyLive = async (
  propertyId: number,
  propertyName: string,
  checklist: Record<string, boolean>,
) => {
  const response = await patch<GoLivePropertyStatus>(GO_LIVE_ENDPOINT, {
    propertyId,
    propertyName,
    checklist,
  });
  return response.data;
};
